import {
	ISlaughterhouseConnectionDto,
	SkioldOneClient,
	SlaughterhouseConnectionDto,
	SlaughterhouseCompany,
} from 'shared/api/api';
import { SkioldDigitalApiBaseUrl } from 'shared/constants';
import { AsyncOperationBuilder2 } from 'shared/helpers/redux-helpers';
import * as Action from './actions';
import { Dispatch } from 'redux';
import { StoreContainer } from 'shared/state/store-container';
import { WebAppState } from 'web/state/store.web';
import moment from 'moment';
import { showWarningSnackbar } from '../snackbar/snackbar-slice';
import { isOverdue } from 'shared/helpers/date-helpers';
import { localized } from 'shared/state/i18n/i18n';

export function GetSlaughterhouseConnectionData(siteId?: string) {
	const lastWarning = (StoreContainer.getState() as WebAppState).slaughterhouseConnections.lastWarning;
	return AsyncOperationBuilder2(
		Action.getSlaughterHouseConnections,
		client => client.slaughterHouseConnection_GetBySiteId(siteId),
		siteId,
		undefined,
		undefined,
		(data: SlaughterhouseConnectionDto[], dispatch: Dispatch<any>) => {
			// default token expiration is 30 days, therefore  get 25 days before
			const warningDate = moment().subtract(25, 'days').toDate();

			// Check if Manuel Login is older than 25 days
			data.some(connection => {
				if (connection.slaughterhouse === SlaughterhouseCompany.Tican && (!connection.lastManuelLogin || connection.lastManuelLogin < warningDate) && (!lastWarning || isOverdue(lastWarning))) {
					dispatch(showWarningSnackbar({ msg: localized('TicanLoginIsOrMightExpireSoon'), duration: null }));
					dispatch(SetLastSlaughterHouseConnectionWarning(new Date()));
					return true;
				}
				return false;
			});
		}
	);
}

export function PostSlaughterhouseConnectionDto(data: ISlaughterhouseConnectionDto) {
	return AsyncOperationBuilder2(
		Action.postSlaughterHouseConnections,
		client => client.slaughterHouseConnection_Post(data as SlaughterhouseConnectionDto),
		data as SlaughterhouseConnectionDto,
	);
}

export function SlaughterHouseConnectionCreateConnection(data: ISlaughterhouseConnectionDto) {
	return AsyncOperationBuilder2(
		Action.postSlaughterHouseConnections,
		client => client.slaughterHouseConnection_CreateConnection(data as SlaughterhouseConnectionDto),
		data as SlaughterhouseConnectionDto,
	);
}

export function GenerateRefreshTokenForSiteId(code: string, siteId: string) {
	return new SkioldOneClient(SkioldDigitalApiBaseUrl).slaughterHouseConnection_GenerateRefreshToken(code, siteId);
}

export function GetDanishCrownAuthState(data: ISlaughterhouseConnectionDto) {
	return new SkioldOneClient(SkioldDigitalApiBaseUrl).slaughterHouseConnection_GetDanishCrownAuthState(
		data.farmNumber,
		data.password,
	);
}

export function SetSlaughterhouseConnection(connection: SlaughterhouseCompany) {
	return async (dispatch: Dispatch<any>) => {
		dispatch(Action.setSlaughterHouseConnection(connection));
	};
}

export function SetLastSlaughterHouseConnectionWarning(date: Date | undefined) {
	return (dispatch: Dispatch<any>) => {
		dispatch(Action.setLastSlaughterHouseConnectionWarning(date));
	};
}
